import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onInsert"];
import { View } from 'foundations-components/components/View';
import { PopoverType } from '../../constants/popover';
// @ts-expect-error not typed
import MorphingLinkPopoverBody from './MorphingLinkPopoverBody';
import { jsx as _jsx } from "react/jsx-runtime";
function InsertLinkPopoverBody(_ref) {
  let {
      onInsert
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(View, {
    "data-test-id": "insert-link-popover-body",
    inlineSize: "294px",
    padding: "500",
    children: /*#__PURE__*/_jsx(MorphingLinkPopoverBody, Object.assign({}, rest, {
      popoverType: PopoverType.INSERT,
      onSubmit: onInsert
    }))
  });
}
InsertLinkPopoverBody.displayName = 'InsertLinkPopoverBody';
export default InsertLinkPopoverBody;